import { gql } from '@apollo/client';

export const VEHICLE_INCIDENT_HISTORY_QUERY = gql`
query VEHICLE_INCIDENT_HISTORY_QUERY($originatorId: ID!, $vehicleId: ID!){
  vehicleIncidentHistory(originatorId: $originatorId, vehicleId: $vehicleId) {
    id
    incidentNumber
    callTime
    classification {
      id
      name
    }
    address {
      id
      name
    }
    vehicleIncidentSpecifics {
      id
      vehicleRole {
        id
        name
      }
      operator {
        id
        personalAttribute {
          id
          lastName
          middleName
          firstName
        }
      }
      vehicle {
        id
      }
    }
    locked
    sealed
  }
}`;

